import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="mapping-feedback"
export default class extends Controller {
  connect() {
    // Listen for successful form submissions
    this.element.addEventListener("turbo:submit-end", this.handleSubmitEnd.bind(this))
  }

  disconnect() {
    this.element.removeEventListener("turbo:submit-end", this.handleSubmitEnd.bind(this))
  }

  handleSubmitEnd(event) {
    // Check if the submission was successful (no validation errors)
    if (event.detail.success) {
      this.showSuccessFeedback()
    }
  }

  showSuccessFeedback() {
    // Add green border temporarily
    this.element.classList.remove("border-gray-600")
    this.element.classList.add("border-green-500", "border-2")
    
    // Also flash the save button green
    const saveButton = this.element.querySelector('button[type="submit"]')
    if (saveButton) {
      saveButton.classList.add("text-green-300", "bg-green-900/30")
    }

    // Remove the effect after 2 seconds
    setTimeout(() => {
      this.element.classList.remove("border-green-500", "border-2")
      this.element.classList.add("border-gray-600")
      
      if (saveButton) {
        saveButton.classList.remove("text-green-300", "bg-green-900/30")
      }
    }, 2000)
  }
}
